import { Schedule } from "../types";
import BaseService from "./base-service";
import { RequestDto } from "./dto/request/request-dto";
import { EmployeeScheduleDto, ScheduleRequestDto } from "./dto/response/schedule-response-dto";

export class ScheduleService extends BaseService {
  private resource = "/api/schedules";

   async addSchedule(params: ScheduleRequestDto, onSuccess: (data: ScheduleRequestDto[]) => Promise<void>, onError: (errorMessage: string) => void) {
    const reqParams = new RequestDto(this.resource, params);
    await this.doPost<ScheduleRequestDto[]>(reqParams, onSuccess, onError);
  }

  async updateSchedule(
    params: { scheduleId: number; schedule: ScheduleRequestDto },
    onSuccess: (data: Schedule) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource + "/" + params.scheduleId, params.schedule);
    await this.doPatch<Schedule>(reqParams, onSuccess, onError);
  }

  async getSchedules(
    params: { branchId: number },
    onSuccess: (data: Schedule[]) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(
      this.resource + "/branch/" + params.branchId,
      null
    );
    await this.doGet<Schedule[]>(reqParams, onSuccess, onError);
  }

  async getEmployeesByScheduleId(
    params: { scheduleId: number },
    onSuccess: (data: EmployeeScheduleDto[]) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(
      this.resource + "/employees/" + params.scheduleId,
      null
    );
    await this.doGet<EmployeeScheduleDto[]>(reqParams, onSuccess, onError);
  }

  async getActiveEmployeesByScheduleId(
    params: { scheduleId: number },
    onSuccess: (data: EmployeeScheduleDto[]) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(
      this.resource + "/employees/active/" + params.scheduleId,
      null
    );
    await this.doGet<EmployeeScheduleDto[]>(reqParams, onSuccess, onError);
  }

  async assignEmployeesToSchedule(
    params: { workScheduleId: number; employeeBranchIds: number[] },
    onSuccess: (data: EmployeeScheduleDto[]) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource + "/assign", params);
    await this.doPost<EmployeeScheduleDto[]>(reqParams, onSuccess, onError);
  }

  async deleteSchedule(
    params: { scheduleId: number },
    onSuccess: (data: null) => void,
    onError: (errorMessage: string) => void
  ) {
    const reqParams = new RequestDto(this.resource + "/" + params.scheduleId, null);
    await this.doDelete(reqParams, onSuccess, onError);
  }
}
